import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import PortfolioMain from "./PortfolioMain";
import Footer from "../../components/Footer";

const Portfolio = () => {
  return (
    <>
      <HeaderFour />

      <PortfolioMain />

      <Footer />
    </>
  );
};

export default Portfolio;
